import { createContext, FC, PropsWithChildren } from 'react'

import {
  ProcessDebugDetailsHook,
  useProcessDebugDetails,
} from '../hooks/useProcessDebugDetails'

export const ProcessDebugDetailsContext = createContext<ProcessDebugDetailsHook | null>(
  null,
)

export const ProcessDebugDetailsProvider: FC<PropsWithChildren> = props => {
  const value = useProcessDebugDetails()

  return (
    <ProcessDebugDetailsContext.Provider value={value}>
      {props.children}
    </ProcessDebugDetailsContext.Provider>
  )
}
